module.exports = __webpack_public_path__ + "static/pic-secondary-d5a995b1e032ab00c3521fffbc6ab47f.jpg";